module.exports = __webpack_public_path__ + "img/_1.7d7baf46.png";